import TrainEventHeader from "../components/TrainEventHeader";
import climate from "../img/events/klimabayern_Smartmap_Banner.png";

export interface TrainEventConfig {
  endDate?: Date;
  header?: React.ReactNode;
  icon?: string;
  iconNoRealtime?: string;
  key: string;
  rake: string;
  startDate?: Date;
}

const events: TrainEventConfig[] = [
  // Climate train
  {
    header: (
      <TrainEventHeader
        href="https://www.klima.bayern.de/"
        imgProps={{
          alt: "Klimastreifenzug",
          src: climate,
        }}
      />
    ),
    icon: "Climate",
    iconNoRealtime: "Climate_NoRealtime",
    key: "Climate",
    rake: "948004231098",
    startDate: new Date("2026-10-19T00:04:00+02:00"),
  },
];

export default events;
